<template>
  <section class="sticky-banner-legacy">
    <div class="sticky-banner-legacy__hero">
      <base-image
        class="sticky-banner-legacy__image"
        :mobile-url="fields.heroMobile?.value?.src"
        :tablet-url="fields.heroTablet?.value?.src"
        :desktop-url="fields.heroDesktop?.value?.src"
        :desktop-alt="fields.heroDesktop?.value?.alt"
        :tablet-alt="fields.heroTablet?.value?.alt"
        :mobile-alt="fields.heroMobile?.value?.alt"
        :full-width="true"
      />
      <div class="container sticky-banner-legacy__content">
        <sc-text
          tag="h1"
          class="sticky-banner-legacy__title"
          :class="titleClasses"
          :field="fields.headerBannerTitle"
        />
        <div class="sticky-banner-legacy__placeholder"></div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Text as ScText } from '@sitecore-jss/sitecore-jss-vue';
import BaseImage from '../../2_elements/BaseImage/BaseImage.vue';
import { useJssStore } from '../../../stores/jssStore';
import type { StickyBannerProps } from '../types';

const jssStore = useJssStore();

withDefaults(defineProps<StickyBannerProps>(), {
  fields: () => ({}),
  params: () => ({}),
});

const titleClasses = computed(() => [jssStore.brandName === 'Belhaven' ? 'font-xxl' : 'font-xl']);
</script>
<style lang="scss">
@import './scss/StickyBanner.scss';
</style>
